import axios from 'axios';
import {ICrudDeleteAction, ICrudGetAction, ICrudPutAction, IPayloadResult} from 'react-jhipster';

import {cleanEntity} from 'app/shared/util/entity-utils';
import {FAILURE, REQUEST, SUCCESS} from 'app/shared/reducers/action-type.util';

import {defaultValue, IAmbulance} from 'app/shared/model/ambulance.model';
import {IPayload} from "react-jhipster/src/type/redux-action.type";
import {IAmbulanceCompact} from 'app/shared/model/ambulance-compact.model';

export const ACTION_TYPES = {
  FETCH_AMBULANCE_LIST: 'ambulance/FETCH_AMBULANCE_LIST',
  FETCH_AMBULANCE_BY_FILTER: 'ambulance/FETCH_AMBULANCE_BY_FILTER',
  FETCH_AMBULANCE: 'ambulance/FETCH_AMBULANCE',
  FETCH_AMBULANCE_COMPACT: 'ambulance/FETCH_AMBULANCE_COMPACT',
  CREATE_AMBULANCE: 'ambulance/CREATE_AMBULANCE',
  UPDATE_AMBULANCE: 'ambulance/UPDATE_AMBULANCE',
  DELETE_AMBULANCE: 'ambulance/DELETE_AMBULANCE',
  FETCH_AMBULANCE_BY_FACILITY_AND_VEHICLE_LEVEL: 'ambulance/FETCH_AMBULANCE_BY_FACILITY_AND_VEHICLE_LEVEL',
  RESET: 'ambulance/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IAmbulance>,
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
  ambulanceByFacilityAndVehicleLevel: [] as ReadonlyArray<IAmbulance>,
  compactEntities: [] as ReadonlyArray<IAmbulanceCompact>,
  compactLoading: false,
};

export type AmbulanceState = Readonly<typeof initialState>;

// Reducer

export default (state: AmbulanceState = initialState, action): AmbulanceState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_AMBULANCE_LIST):
    case REQUEST(ACTION_TYPES.FETCH_AMBULANCE_BY_FILTER):
    case REQUEST(ACTION_TYPES.FETCH_AMBULANCE):
    case REQUEST(ACTION_TYPES.FETCH_AMBULANCE_BY_FACILITY_AND_VEHICLE_LEVEL):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.FETCH_AMBULANCE_COMPACT):
      return {
        ...state,
        errorMessage: null,
        compactLoading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_AMBULANCE):
    case REQUEST(ACTION_TYPES.UPDATE_AMBULANCE):
    case REQUEST(ACTION_TYPES.DELETE_AMBULANCE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_AMBULANCE_LIST):
    case FAILURE(ACTION_TYPES.FETCH_AMBULANCE_BY_FILTER):
    case FAILURE(ACTION_TYPES.FETCH_AMBULANCE):
    case FAILURE(ACTION_TYPES.CREATE_AMBULANCE):
    case FAILURE(ACTION_TYPES.UPDATE_AMBULANCE):
    case FAILURE(ACTION_TYPES.DELETE_AMBULANCE):
    case FAILURE(ACTION_TYPES.FETCH_AMBULANCE_BY_FACILITY_AND_VEHICLE_LEVEL):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case FAILURE(ACTION_TYPES.FETCH_AMBULANCE_COMPACT):
      return {
        ...state,
        compactLoading: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_AMBULANCE_LIST):
    case SUCCESS(ACTION_TYPES.FETCH_AMBULANCE_BY_FILTER):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
        totalItems: parseInt(action.payload.headers['x-total-count'], 10),
      };
    case SUCCESS(ACTION_TYPES.FETCH_AMBULANCE):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.FETCH_AMBULANCE_COMPACT):
      return {
        ...state,
        compactLoading: false,
        compactEntities: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_AMBULANCE):
    case SUCCESS(ACTION_TYPES.UPDATE_AMBULANCE):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.FETCH_AMBULANCE_BY_FACILITY_AND_VEHICLE_LEVEL):
      return {
        ...state,
        loading: false,
        ambulanceByFacilityAndVehicleLevel: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_AMBULANCE):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

const apiUrl = 'api/ambulances';

// Actions

export const getEntities: (page?, size?, sort?, countryId?) => IPayload<IAmbulance> | IPayloadResult<IAmbulance> = (page?, size?, sort?, countryId?) => {
  const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}&countryId=${countryId}` : ''}`;
  return {
    type: ACTION_TYPES.FETCH_AMBULANCE_LIST,
    payload: axios.get<IAmbulance>(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`),
  };
};

export interface IAmbulanceFilter {
  name?: string;
  countryId?: string;
  regionId?: string;
  districtId?: string;
  activePage?: number;
  sort?: {
    sortOrder?: string;
    sortType?: string;
  };
}

export const getEntitiesByFilter = (filter: IAmbulanceFilter) => {
  let requestUrl = `${apiUrl}-by-filter?cacheBuster=${new Date().getTime()}`;

  if (filter.activePage !== undefined) {
    requestUrl += `&page=${filter.activePage}&size=25`;
  }

  if (filter.sort) {
    requestUrl += `&sort=${filter.sort.sortType},${filter.sort.sortOrder}`;
  }

  if (filter.name) {
    requestUrl += `&name=${encodeURIComponent(filter.name)}`;
  }

  if (filter.countryId) {
    requestUrl += `&countryId=${filter.countryId}`;
  }

  if (filter.regionId) {
    requestUrl += `&regionId=${filter.regionId}`;
  }

  if (filter.districtId) {
    requestUrl += `&districtId=${filter.districtId}`;
  }

  return {
    type: ACTION_TYPES.FETCH_AMBULANCE_BY_FILTER,
    payload: axios.get<IAmbulance>(requestUrl),
  };
};

export const getAmbulanceByName: (searchString, countryId) => IPayload<IAmbulance> | IPayloadResult<IAmbulance> = (searchString, countryId) => {
  const requestUrl = 'api/search/search-ambulance-by-name';
  return {
    type: ACTION_TYPES.FETCH_AMBULANCE_LIST,
    payload: axios.get<IAmbulance>(`${requestUrl + '/' + searchString + '/' + countryId}${'?'}cacheBuster=${new Date().getTime()}`),
  };
};


export const getEntity: ICrudGetAction<IAmbulance> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_AMBULANCE,
    payload: axios.get<IAmbulance>(requestUrl),
  };
};

export const createEntity: ICrudPutAction<IAmbulance> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_AMBULANCE,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  // dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IAmbulance> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_AMBULANCE,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const deleteEntity: ICrudDeleteAction<IAmbulance> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_AMBULANCE,
    payload: axios.delete(requestUrl),
  });
  dispatch(getEntities());
  return result;
};

export const getAmbulanceDriversForFacilityVehicleRequiredLevel = (healthcareFacilityId: string, requiredLevel: number) => {
  const requestUrl = `api/ambulance-by-facility-and-vehicle-level?healthcareFacilityId=${healthcareFacilityId}&requiredLevel=${requiredLevel}`;
  return {
    type: ACTION_TYPES.FETCH_AMBULANCE_BY_FACILITY_AND_VEHICLE_LEVEL,
    payload: axios.get<IAmbulance[]>(`${requestUrl}&cacheBuster=${new Date().getTime()}`),
  };
};

export const getAmbulancesCompact = (countryId?) => {
  const requestUrl = `${apiUrl}/compact`;
  const params = new URLSearchParams();
  if (countryId) params.append('countryId', countryId);

  return {
    type: ACTION_TYPES.FETCH_AMBULANCE_COMPACT,
    payload: axios.get<IAmbulanceCompact[]>(`${requestUrl}?${params.toString()}`),
  };
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
